import * as React from 'react';
import S from './Form.styles';
const ErrorSummary = (props) => {
    return (React.createElement(S.ErrorList, null, props.errors.map((error) => (React.createElement(S.ErrorListItem, { key: error },
        React.createElement("span", null, "!"),
        " ",
        error)))));
};
export default ErrorSummary;
